<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <!-- 导航条 -->
    <el-header class="headerManu"><nav-header :active-index="activeIndex"></nav-header></el-header>

    <el-main id="router_view">
      <el-row>
        <!--左侧菜单-->
        <el-col  id="menu_container" :span="menuSpan">
          <el-menu
            ref="el_menu_risk"
            style="width: 100%;"
            id="ChangeRisksMenus"
            v-show="activeIndex=='risk'"

            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose">
            <el-submenu index="population_risks" class="menuGroup_title">
              <template slot="title" style="background-color: #ff0000;"><span class="GS_menuItem">Population risks</span></template>
              <el-menu-item index="Heatwave" @click="foldMenuClick"><span class="GS_menuItem">Heatwave</span></el-menu-item>
              <el-menu-item index="Flood" @click="foldMenuClick"><span class="GS_menuItem">Flood</span></el-menu-item>
            </el-submenu>
            <el-submenu index="Crop_Yield_Risks" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span class="GS_menuItem">Crop yield risks</span></template>
              <el-menu-item index="Rice" @click="foldMenuClick"><span class="GS_menuItem">Rice</span></el-menu-item>
              <el-menu-item index="Wheat" @click="foldMenuClick"><span class="GS_menuItem">Wheat</span></el-menu-item>
              <el-menu-item index="Maize" @click="foldMenuClick"><span class="GS_menuItem">Maize</span></el-menu-item>
            </el-submenu>
            <el-submenu index="gdp_loss_risks" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span class="GS_menuItem">GDP loss risks</span></template>
              <el-menu-item index="GDPLossRisksFlood" @click="foldMenuClick"><span class="GS_menuItem">Flood</span></el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>

        <!--地图容器-->
        <el-col :span="mapSpan" style="position: relative">
          <!-- Map container-->
          <div id="map" style="width: auto; z-index: 1"></div>
          <div  id="mapResizeButton"
                style="cursor: pointer;
                background-color: rgb(67,133,185); width: 27px; height: 98px;padding: 2px;border-radius: 3px; border: 3px solid rgb(135,206,235)">
            <img :src="zoomIn" style="width: 100%; color: white;margin-left: -1px; width: 30px;height: 30px;" title="Operation manual"  @click="openOperationMenu"/>
            <img :src="zoomOut" style="width: 100%; color: white;margin-top: 5px; margin-bottom: 5px; width: 22px;height: 22px;" @click="openDescriptionDlg"/>
            <img :src="menuResizeIcon" style="width: 100%; color: white;width: 25px;height: 25px;" @click="mapResize"/>
          </div>


          <!--图例-->
          <map-lengend
            :title="legendTitle"
            ref="ref_mapLegend"
            @colorsChanged="colorsChanged"
            :legends="selectedMapLegendsStyle"
            class="legend"
            id="IDLegend"
            @layoutupdate="legend_layoutupdate"
            style="display: none;"></map-lengend>


          <!--Radio Group-->
          <div  class="radio_group">

            <el-radio-group v-model="radioG_cc_prcptot" class="item_one" @change="radioGroup_change" v-show="radioData.length>0 && radioData_visible ">
              <el-radio :label="item.radio_code"  v-for="(item,index) in radioData" :key="index">{{item.radio_title}}</el-radio>
            </el-radio-group>

            <!--时段&场景-->
            <el-cascader class="GS_SHIDUAN" placeholder="Switch" v-model="selected_cascader"
                         :options="cascader_options" @change="radioGroup_change" v-if="cascader_options.length>0" style="margin-left: 10px;"></el-cascader>

            <el-radio-group v-model="radioG_cc_prcptot_type" class="item_more" @change="radioGroup_change" v-show="cc_map_datamodel_visible()">
              <el-radio label="value">Value</el-radio>
              <el-radio label="change">Change</el-radio>
            </el-radio-group>

            <el-radio-group v-model="radioG_cc_prcptot_mm" class="item_more" @change="radioGroup_change"  v-show="MMESVisible" style="margin-left: 10px;">
              <el-radio label="mme">MME</el-radio>
              <el-radio label="mms">MMS</el-radio>
            </el-radio-group>
          </div>

          <!--map layer source name  | toolabs-->
          <div class="css_map_footer"  v-if="selectedRasterMapSrouce!=undefined?true:false">
            <div class="bg"></div>
            <div class="context">
              {{ selectedRasterMapSrouce.toUpperCase()}}
              <a id="image-download" download="map.png"></a>
              <!--map export png-->
              <img :src="file_download"  style="float: left;margin-left: 10px; margin-top: 5px;width: 30px;height: 30px;" @click="mapExport" title="Map Export"/>
              <img :src="file_detail"  style="float: left;margin-left: 15px; margin-top: 6px;width: 26px;height: 26px;" @click="mapDeitalView"/>
              <!--map legend controller-->
              <div style="float:right; width: 25px;height: 25px;margin-right: 5px;" @click="legend_layoutupdate_show">
                <img :src="legendModel==0?icon_zhankai_w:icon_shousuo_w" style="width: 100%; margin-top: 7px;" >
              </div>
            </div>

          </div>


          <div id="popup" class="ol-popup">
            <el-col style="font-family: 'Courier New';">

              <el-row style="height: 20px; line-height: 20px; margin-bottom: 10px; width: 300px;" v-show="dType==2" >
                <el-col :span=4 style="color: transparent">2323232</el-col>
                <el-col :span=16>Query Result</el-col>
                <el-col :span=4 style="text-align: right;">
                  <a href="#" id="popup-closer" class="ol-popup-closer" style="font-size: 17px;"></a>
                </el-col>
              </el-row>

              <el-row v-show="dType==2" style="background-color: transparent;padding: 5px 0px; border-bottom: solid 1px lightgrey;" v-for="(item,index) in tableData" :key="index">
                <div >
                  <el-col :span=16 style="text-align: left;">{{item.lable}}</el-col>
                  <el-col :span=8>{{item.value}}</el-col>
                </div>
              </el-row>

              <el-row v-show="dType==1" style="width: 120px;">
                <el-row style="background-color: transparent; line-height: 30px; height: 30px; width: auto;">
                  <el-col :span=20 style="text-align: left;"><div style="padding-right: 20px;">{{
                      selectedRasterMapData=="NO DATA"?"NO DATA":parseFloat(selectedRasterMapData).toFixed(2)
                    }}</div></el-col>
                  <el-col :span=4 style="text-align: right;">
                    <a href="#" id="popup-closer2" class="ol-popup-closer" style="font-size: 17px;"></a>
                  </el-col>
                </el-row>
              </el-row>

            </el-col>

          </div>


        </el-col>



      </el-row>
    </el-main>


    <el-dialog
      title="标题占位符-"
      :visible.sync="descriptionDlgVisible"
      width="60%"
      :before-close="closeDescriptionDlg">
      <div style="text-align: left;width: 100%; height: 600px;" >
        此部分放置系统说明文档
      </div>
    </el-dialog>



  </el-container>
</template>

<script>

  import  ihMap  from "@/components/map/IHMap";
  import  ihVerticalTabs from "@/components/widgets/IHVerticalTabs";
  import  ihSignalVerticalTabs from "@/components/widgets/IHSignalVerticalTabs";
  import  mapLengend from "@/view/BSD/components/MapLengend";


  import 'ol/ol.css'
  import Overlay from 'ol/Overlay';
  import {toSize} from 'ol/size';
  import {menus_env,menus_exposure,menus_risk,radioGroupData,cascaderData,radioGroupData_V2, Risk_radioGroupData,Risk_cascaderData} from "./BSDConfig"
  import {IHMapUtils} from "../../components/map/common/IHMapUtils"

  import {TDM_LAYER_EVA_C} from "../../components/map/common/constant"

  import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";

  import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
  import { TileWMS, OSM, Vector as VectorSource } from "ol/source";
  import GeoJSON from "ol/format/GeoJSON";

  //Init Icon Params
  let menuresizeicon_min =  require( '../../assets/icons/menu_shousuo_w.png');
  let menuresizeicon_max =  require( '../../assets/icons/menu_zhankai_w.png');
  let menuresizeicon_description =  require( '../../assets/icons/description.png');

  let mapZoomIn =  require( '../../assets/icons/加号.png');
  let mapZoomOut =  require( '../../assets/icons/减号.png');




  let icon_zhankai_w =  require( '../../assets/icons/icon_zhankai_w.png');
  let icon_shousuo_w =  require( '../../assets/icons/icon_shousuo_w.png');
  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  let file_download =  require( '../../assets/icons/download.png');
  let file_detail =  require( '../../assets/icons/查看详情.png');
  let bunMenuIcon =  require( '../../assets/imgs/bunMenu.png');

  //
  import BSDConfigLegendTitle from "./BSDConfigLegendTitle_Risk"
  import AppConfig from "./AppConfig";
  import {api_bnu_getLayerLegends ,api_bnu_docDownloadTimes} from "@/api";
  import {geoserver,geoserver_local,geoserver_local_tiff,geoserver_basic} from "./GEOConfig"
  import NavHeader from "./components/NavHeader";
  import {reverseMapLegend} from "./mapTools"


  export default {
    name: "BSDMapRISK",
    components:{ihMap,ihVerticalTabs,ihSignalVerticalTabs,mapLengend,NavHeader},
    data(){
      return {
        zoomIn:mapZoomIn,
        zoomOut:mapZoomOut,

        dType:2,
        descriptionDlgVisible:false,
        descriptionDlgHeight:800,
        activeIndex: "risk",
        menuSpan:0,
        mapSpan:24,
        menu_width:null,
        content_height:null,
        menuResizeIcon: menuresizeicon_max,
        menuresizeicon_description,
        logo: bsd_logo,
        //菜单配置
        mTabs:menus_env,
        //地图相关的
        map:null,
        vector_layer:null,
        geoserver:geoserver,
        geoserver_local:geoserver_local,
        geoserver_local_tiff:geoserver_local_tiff,
        geoserver_basic:geoserver_basic,

        lastClicedMenuItem:"Heatwave",
        lastClicedMenuItemGroup:"cc_precipitation",
        mapUtils:null,
        //Radio Group Data
        radioData:[],
        radioData_visible:true,
        radioG_cc_prcptot:"ann",
        //Cascader
        default_activemenu_cc:'cc_tmean_mean',
        selected_cascader:["2000_s0"],
        cascader_options:[],
        radioG_cc_prcptot_type:"value",
        radioG_cc_prcptot_mm:"mme",
        selectedRasterMapSrouce:undefined,
        selectedRasterMapLayer:undefined,
        selectedRasterMapWS:undefined,
        //legend
        legendModel:0,
        icon_zhankai_w,
        icon_shousuo_w,
        file_download,file_detail,
        //overlay
        defaultMapOverlay:undefined,
        selectedRasterMapData:undefined,
        //selected Map legends
        selectedMapLegendsStyle:undefined,
        loginUser:undefined,

        //pdf
        dialogVisible:false,
        pageCount: 0, //总页码
        pdfUrl: "",
        numPages: 0,
        loadedRatio: 0, //提示语

        //
        basicOceanLayer:undefined,
        MMESVisible:true,//特征值可见性控制
        bunMenuIcon,
        currentStyle:"",
        legendTitle:"Map Lengend",
        tableData:[],
        defaultActive:"Heatwave"
      }
    },
    methods:{
      //app's operation menu
      openOperationMenu(){
        //window.open(AppConfig.minio_server+"/bun/Manual%20for%20the%20use%20of%20the%20global%20typical%20disaster%20risk%20digital%20mapping%20platform.docx","_blank");
        let mzoom = this.map.getView().getZoom();
        if(mzoom>=18){
          return;
        }
        let mcenter = this.map.getView().getCenter();
        this.map.getView().setZoom(mzoom+1);
        this.map.getView().setCenter(mcenter);
      },

      //打开属性对话框
      openDescriptionDlg(){
        //this.descriptionDlgVisible = true;
        let mzoom = this.map.getView().getZoom();
        if(mzoom>1){
          let mcenter = this.map.getView().getCenter();
          this.map.getView().setZoom(mzoom-1);
          this.map.getView().setCenter(mcenter);
        }

      },
      closeDescriptionDlg(){
        this.descriptionDlgVisible = false;
      },

      colorsChanged(colorGroups){
        this.selectedMapLegendsStyle = colorGroups;
        this.dynamicLodingWMSLayer(false);
      },

      switchFeedback(){
        let userData = this.$appStorage.getUserData();
        if(userData==undefined){
          this.$router.push({path:'/BNUMap/Login'})
        }else {
          this.$router.push({path:'/BNUMap/Feedback'})
        }
      },
      /**
       * user login
       * */
      Login(){
        let userData = this.$appStorage.getUserData();
        if(userData==undefined){
          this.$router.push({path:'/BNUMap/Login'})
        }else {
          alert(JSON.stringify(userData));
        }
      },
      /**
       * login out
       * */
      loginOut() {
        this.$confirm('Do you want to log out?', 'Prompt', {
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          //清除缓存，修改登录状态
          this.$appStorage.userLogout();
          this.loginUser = this.$appStorage.getUserMailbox();
        })
      },



      handleSelect(key, keyPath) {
        this.activeIndex = key;
        console.log("key = ",key,"&activeIndex =",this.activeIndex);
        if(key =="env")
        {
          this.mTabs = menus_env;
        }
        else if(key=="risk") {
          this.mTabs = menus_risk;
        }

        let rPath = "/BNUMap/"+key;
        this.$router.push({path:rPath})
      },

      menuClicked:function (item) {
        console.log("menu clicked = ",item);
      },

      //init the map container
      initMap:function () {
        this.map = this.$olMapUtils.init(
          {
            map:document.getElementById("map"),
            center:[90.70313,17.92969],
            initZoom:1,
            geoserver:this.geoserver_local
          })
      },

      initLayout(){
        const screen_height = document.body.clientHeight;
        const page_header = 60;
        const content_height = screen_height -  page_header;
        document.getElementById("root_container").style.height = document.body.clientHeight+"px";
        document.getElementById("router_view").style.height = document.body.clientHeight - 60+"px";
        document.getElementById("map").style.height = document.body.clientHeight - 60+"px";
        document.getElementById("menu_container").style.height =content_height+"px";

        this.menu_width = document.getElementById("menu_container").clientWidth;
        //document.getElementById("climateMenu").style.width = this.menu_width+"px";
        document.getElementById("ChangeRisksMenus").style.width = this.menu_width+"px";
        this.content_height = document.body.clientHeight - 60;

        document.getElementById("mapResizeButton").style.top ="5px";
        document.getElementById("mapResizeButton").style.marginLeft ="5px";
      },

      mapResize(){
        if(this.menuSpan==3) {
          this.menuSpan = 0;
          this.mapSpan = 24;
          this.map.setSize(new toSize([document.body.clientWidth ,this.content_height]));
          this.menuResizeIcon = menuresizeicon_max;
        } else {
          this.menuSpan = 3;
          this.mapSpan = 21;
          this.map.setSize(new toSize([(document.body.clientWidth - this.menu_width),this.content_height]));
          this.menuResizeIcon = menuresizeicon_min;
        }
      },

      handleOpen(){},
      handleClose(){},

      //折叠菜单点击事件
      foldMenuClick(item)
      {
        console.log("MenuClick Actijon = item = ",item);
        const menuIndex = item.index;
        const menuGroup = item.$attrs.menuGroup;
        const menuIndex_lowercase = menuIndex.toLowerCase();
        if(menuIndex_lowercase=="heatwave" || menuIndex_lowercase=="flood" || menuIndex_lowercase=="gdplossrisksflood"){
          this.radioData_visible = false;
        }else {
          this.radioData_visible =true;
        }
        //特征值Radio可见性控制
        this.foldMenuClickAcion(menuIndex,menuGroup);
      },
      //菜单点击
      foldMenuClickAcion(menuIndex,menuGroup)
      {
        console.log("menuIndex = ",menuIndex,"menuGroup = ",menuGroup);
        this.lastClicedMenuItem = menuIndex;
        //更新年份配置数据
        this.cascader_options = Risk_cascaderData[this.lastClicedMenuItem];
        if(menuGroup!=this.lastClicedMenuItemGroup){
          let _cascader_ary = new Array();
          _cascader_ary.push(this.cascader_options[0].value);
          this.selected_cascader = _cascader_ary;
        }

        //Update Radio Group ConfigData
        this.radioG_MapTime_updateConfig();
        //
        this.radioGroup_change();
        //
        this.lastClicedMenuItemGroup =menuGroup;
      },
      //更新数据
      radioGroup_change()
      {
        //地图数据模型可见性控制住
        this.cc_map_datamodel_visible();
        //Raster Layer
        this.dynamicLodingWMSLayer();
      },


      //动态加载图层
      dynamicLodingWMSLayer(needUpdateLegends=true){

        if(this.defaultMapOverlay){
          this.defaultMapOverlay.setPosition(undefined);
        }
        let menu_1 = this.lastClicedMenuItem.split("_")[0];
        let menu_2 = this.lastClicedMenuItem.split("_")[1];
        let menu_3 = this.lastClicedMenuItem.split("_")[2];
        console.log("menutype = ",menu_1," &subMenu = ",menu_2," &subMenu = ",menu_3);
        console.log("radioG_cc_prcptot_type = ",this.radioG_cc_prcptot_type);
        console.log("radioG_cc_prcptot_mm = ",this.radioG_cc_prcptot_mm);
        console.log("selected_cascader = ",this.selected_cascader);
        console.log("this.radioG_cc_prcptot = ",this.radioG_cc_prcptot);

        let layerCode = "risk_"+this.lastClicedMenuItem.toLowerCase()+"_"+this.radioG_cc_prcptot+"_";
        const selected_cascader_value = this.selected_cascader[this.selected_cascader.length-1];
        layerCode =layerCode+selected_cascader_value;

        if(selected_cascader_value=="2000s_s0"){//如果是Baseline
          layerCode =layerCode+"_value";
        }else {
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_type;
        }

        if(this.lastClicedMenuItem.toLowerCase()=="wheat"){
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_mm+"_gobal";
        }else {
          layerCode = layerCode +"_"+this.radioG_cc_prcptot_mm+"_global";
        }


        //删除旧Raster图层
        if(this.selectedRasterMapLayer!=undefined){
          this.map.removeLayer(this.selectedRasterMapLayer);
          this.selectedRasterMapLayer = undefined;
        }


        let wms_ws = "Risk_"+this.lastClicedMenuItem.toUpperCase()+"_"+this.radioG_cc_prcptot.toUpperCase();
        if(this.lastClicedMenuItem=="Wheat"){
          wms_ws = "Risk_"+this.lastClicedMenuItem+"_"+this.radioG_cc_prcptot.toUpperCase();
        }

        console.log("人口风险：：热浪"); //
        console.log("::this.lastClicedMenuItem = ",this.lastClicedMenuItem);
        if(this.lastClicedMenuItem.toLowerCase()=="heatwave"){
          let map_ws = "population_risks_heatwaves";
          let msp_layerCode = map_ws+":risk_pop_ht_";

          if(selected_cascader_value=="2000s_s0"){//如果是Baseline
            msp_layerCode =msp_layerCode+selected_cascader_value+"_value_"+this.radioG_cc_prcptot_mm+"_global";
          }else {
            msp_layerCode =msp_layerCode+selected_cascader_value+"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
          }
          layerCode =msp_layerCode;
          wms_ws = map_ws;
          console.log("Population Risk:: layer code = ",layerCode);
        }
        else if(this.lastClicedMenuItem.toLowerCase()=="flood"){
          let map_ws = "population_risks_flood";
          let msp_layerCode = map_ws+":risk_pop_fld_";

          if(selected_cascader_value=="2000s_s0"){//如果是Baseline
            msp_layerCode =msp_layerCode+selected_cascader_value+"_value_"+this.radioG_cc_prcptot_mm+"_global";
          }else {
            msp_layerCode =msp_layerCode+selected_cascader_value+"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
          }
          layerCode =msp_layerCode;
          wms_ws = map_ws;
          console.log("Population Risk:: layer code = ",layerCode);
        }
        else if(this.lastClicedMenuItem.toLowerCase()=="gdplossrisksflood"){
          let map_ws = "gdp_loss_risk_flood";
          let msp_layerCode = map_ws+":risk_gdp_fld_";

          if(selected_cascader_value=="2000s_s0"){//如果是Baseline
            msp_layerCode =msp_layerCode+selected_cascader_value+"_value_"+this.radioG_cc_prcptot_mm+"_global";
          }else {
            msp_layerCode =msp_layerCode+selected_cascader_value+"_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_global";
          }
          layerCode =msp_layerCode;
          wms_ws = map_ws;
          console.log("Population Risk:: layer code = ",layerCode);
        }

        //拼接工作空间
        console.log("拼接工作空间");
        wms_ws = wms_ws.toLowerCase();
        let tifflayer_accessurl = this.readGeoTiffAccessUrl(wms_ws);

        //更新图例数据
        this.selectedRasterMapWS = tifflayer_accessurl;
        this.selectedRasterMapSrouce = layerCode;

        let layerSytleColorGroups = undefined;
        console.log("needUpdateLegends = ",needUpdateLegends);
        if(needUpdateLegends){
          console.log("needUpdateLegends =aaaaaaaaaa");
          this.updateMapLengends(layerCode,wms_ws);
          this.$refs.ref_mapLegend.updateHeight();
        }else {
          console.log("abc");
          let styleData= this.$olMapUtils.colorGroupReverse_NODATA_BLACK(this.selectedMapLegendsStyle);
          //此处采用：： intervals 的方式
          //layerSytleColorGroups =this.$olMapUtils.parseSLDBodyWithType(this.$x2js,layerCode, styleData,"intervals");
          layerSytleColorGroups =this.$olMapUtils.parseSLDBodyWithType(this.$x2js,layerCode, styleData,"RAMP");
          console.log("geoServer = ",tifflayer_accessurl," && layerCode = ",layerCode,"layerSytleColorGroups = ",layerSytleColorGroups);
        }
        this.$refs.ref_mapLegend.updateHeight();

        console.log("this.$olMapUtils.addWMSLayer");
        this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
          defaultStyles:layerSytleColorGroups,
          layerName:layerCode,
          layerCode:layerCode,
          visible:true,
          geoServer:tifflayer_accessurl,
          zIndex:0,olTag:"pesc"});

        //添加英文注解
        this.addTDM_LAYER_EVA_C();
        //更新海洋背景
        this.updateOceanMapLayer();
        //
        this.updateMapLegendTitle();
      },
      //更新地图图例
      updateMapLegendTitle(){
        let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        let title = BSDConfigLegendTitle[current_layer_code];
        if(title==undefined){
          current_layer_code = current_layer_code.replace("GLOBAL","GOBAL").toUpperCase();
          title = BSDConfigLegendTitle[current_layer_code];
        }
        this.legendTitle =title;
      },

      //地图数据模式加载 - Change & Value
      cc_map_datamodel_visible(){
        let selected_cascader_laster = this.selected_cascader[this.selected_cascader.length-1];
        if(selected_cascader_laster=="2000_s0" || selected_cascader_laster=="2000s_s0"){
          return false;
        }
        return true;
      },



      /**
       * Annual && Winter && Summer 配置参数更新
       * */
      radioG_MapTime_updateConfig(){
        let selectedRadioGroupData =  Risk_radioGroupData[this.lastClicedMenuItem];
        if(selectedRadioGroupData!=undefined && selectedRadioGroupData.length>0) {
          console.log("radioG_MapTime_updateConfig::lastClicedMenuItem = ",this.lastClicedMenuItem," && HAS DATA");
          this.radioData = selectedRadioGroupData;
          let selectedRadioGroupData_default = selectedRadioGroupData[0];
          this.radioG_cc_prcptot = selectedRadioGroupData_default.radio_code;
        }else {
          console.log("radioG_MapTime_updateConfig::lastClicedMenuItem = ",this.lastClicedMenuItem," && HAS NO DATA");
        }
      },


      async read_api_bnu_getLayerLegends(legends_params){
       // return  await api_bnu_getLayerLegends(legends_params).then(res=>{
       //    console.log("api_bnu_getLayerLegends:: data = ",res.data);
       //    return res.data;
       //  })
        console.log("hello");
        return  await api_bnu_getLayerLegends(legends_params);
      },

      /**
       *
       **/
      readGeoTiffAccessUrl(workspace){
        console.log("readGeoTiffAccessUrl");
        workspace = workspace.toLowerCase();
        return this.geoserver_basic+workspace+"/wms";
      },

      /**
       * 级联菜单 2020年9月28日16:09:41
       * */
      cascader_changed(value){
        console.log(value);
      },

      /**
       * Resize Map Container
       * */
      mapSourceLayout(){
        if(this.selectedRasterMapSrouce==undefined){
          document.getElementById("IDLegend").style.bottom = "40px";
        } else {
          document.getElementById("IDLegend").style.bottom = "40px";
        }
      },

      /**
       * 根据路由路径打开默认的地图图层
       * */
      openDefaultMapSource(){

        // let routerPath = this.$route.path;
        // let pathAry = routerPath.split("\/");
        // let last_router_path = pathAry[pathAry.length-1];
        // if(last_router_path=="risk")//气候的默认图层
        // {
        //   //默认打开一个菜单
        //   this.$refs.el_menu_risk.open('Crop_Yield_Risks');
        //   //默认加载一个地图图层
        //   this.foldMenuClick({
        //     index:"Heatwave",
        //     $attrs:{
        //       menuGroup:"cc_temprature"
        //     }
        //   })
        // }


        let sm = this.$route.query.sm
        if(sm==undefined){
          sm = "Heatwave";
        }
        this.default_activemenu_cc = sm;
        this.selected_cascader =["2000s_s0"];
        if(sm=="Heatwave"){
          this.$refs.el_menu_risk.open('population_risks');
          this.foldMenuClick({
            index:"Heatwave",
            $attrs:{
              menuGroup:"cc_temprature"
            }
          })
        }else if(sm=="Rice"){
          this.$refs.el_menu_risk.open('Crop_Yield_Risks');
          this.foldMenuClick({
            index:"Rice",
            $attrs:{
              menuGroup:"cc_precipitation"
            }
          })
        }else if(sm=="GDPLossRisksFlood"){
          this.$refs.el_menu_risk.open('gdp_loss_risks');
          this.foldMenuClick({
            index:"GDPLossRisksFlood",
            $attrs:{
              menuGroup:"cc_temprature"
            }
          })
        }

        this.defaultActive = sm;

      },


      legend_layoutupdate(data){
        let obj = document.getElementById("IDLegend");
        let obj_height = obj.style.height;
        obj.style.bottom = (0-parseInt(data))-50 +"px";
      },

      legend_layoutupdate_show(){
        let obj = document.getElementById("IDLegend");
        obj.style.bottom = "40px";

        if(this.legendModel==0){
          this.legendModel=1;
          document.getElementById("IDLegend").style.display = 'block';
        }else {
          this.legendModel = 0;
          document.getElementById("IDLegend").style.display = 'none';
        }

        if(this.legendModel==1){
          this.$refs.ref_mapLegend.updateHeight();
        }
      },


      /**
       * @description 地图详情预览
       * */
      mapDeitalView(){
        let clickedMenuItem = this.lastClicedMenuItem.toLowerCase();
        let file_url = AppConfig.minio_server+"/bun/";
        if(clickedMenuItem=="heatwave"){
          file_url =file_url +"risk/population_risks/heatwave/";
          file_url =file_url + this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        } else if(clickedMenuItem=="flood"){
          file_url =file_url +"risk/population_risks/flood/";
          file_url =file_url + this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        }
        else if(clickedMenuItem=="rice") {
          if(this.radioG_cc_prcptot=="mean"){
            file_url = file_url +"risk/crop_yield_risks/rice/mean_yield/";
          }else if(this.radioG_cc_prcptot=="var"){
            file_url = file_url +"risk/crop_yield_risks/rice/variability_yield/";
          }else if(this.radioG_cc_prcptot=="ext"){
            file_url = file_url +"risk/crop_yield_risks/rice/extreme_yield/";
          }
          file_url =file_url + this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        }
        else if(clickedMenuItem == "wheat"){
          if(this.radioG_cc_prcptot=="mean"){
            file_url = file_url +"risk/crop_yield_risks/wheat/mean_yield/";
          }else if(this.radioG_cc_prcptot=="var"){
            file_url = file_url +"risk/crop_yield_risks/wheat/variability_yield/";
          }else if(this.radioG_cc_prcptot=="ext"){
            file_url = file_url +"risk/crop_yield_risks/wheat/extreme_yield/";
          }
          file_url =file_url + this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        }
        else if(clickedMenuItem == "maize"){
          if(this.radioG_cc_prcptot=="mean"){
            file_url = file_url +"risk/crop_yield_risks/maize/mean_yield/";
          }else if(this.radioG_cc_prcptot=="var"){
            file_url = file_url +"risk/crop_yield_risks/maize/variability_yield/";
          }else if(this.radioG_cc_prcptot=="ext"){
            file_url = file_url +"risk/crop_yield_risks/maize/extreme_yield/";
          }
          let rUrl = this.selectedRasterMapSrouce;
          rUrl = rUrl.replaceAll("global",'gobal');
          file_url =file_url + rUrl.toUpperCase();//转换为大写
        }else if(clickedMenuItem=="gdplossrisksflood"){
          file_url =file_url +"risk/gdp_loss_risks/flood/";
          file_url =file_url + this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        }

        file_url =file_url + ".docx";
        console.log("Download Map Description File = ",file_url);
        window.open(file_url,"_blank");
      },

      closeDialog() {
        this.dialogVisible = false;
      },
      /**
       * 下载Word文档
       * */
      mapDataFileDownload(){
        window.open("https://cbcdn.cafewallet.cn/docfile/FileDownlaodTtest_20201127.pdf");
      },

      /**
       * @author zhangchengguo
       * @description 导出地图文件
       * */
      doMapExport(){
        let _map = this.map;
        this.map.once('rendercomplete', function () {
          var mapCanvas = document.createElement('canvas');
          var size =_map.getSize();
          mapCanvas.width = size[0];
          mapCanvas.height = size[1];
          var mapContext = mapCanvas.getContext('2d');
          Array.prototype.forEach.call(
            document.querySelectorAll('.ol-layer canvas'),
            function (canvas) {
              if (canvas.width > 0) {
                var opacity = canvas.parentNode.style.opacity;
                mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                var transform = canvas.style.transform;
                // Get the transform parameters from the style's transform matrix
                var matrix = transform
                  .match(/^matrix\(([^\(]*)\)$/)[1]
                  .split(',')
                  .map(Number);
                // Apply the transform to the export map context
                CanvasRenderingContext2D.prototype.setTransform.apply(
                  mapContext,
                  matrix
                );
                mapContext.drawImage(canvas, 0, 0);
              }
            }
          );
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
          } else {
            var link = document.getElementById('image-download');
            link.href = mapCanvas.toDataURL();
            link.click();
          }
        });
        _map.renderSync();
      },

      mapExport(){
        console.log("BSDMapRISK::mapExport");
        let _this = this;
        api_bnu_docDownloadTimes({path:this.selectedRasterMapSrouce.toLowerCase()}).then(res=>{
          let rData = res.data;
          console.log("rData = ",rData);
          _this.doMapExport();
        })
      },

      /**
       * 矢量英文注记
       * */
      addTDM_LAYER_EVA_C(){

        let  selectedLayer = undefined;
        const layers = this.map.getLayers();
        const layer_lenght = layers.getLength();

        for(let i=0;i<layer_lenght;i++){
          const item = layers.item(i);
          const item_name = item.name;
          //console.log("index = ",i," &layer = ",item,"&item_name = ",item_name);
          if(item_name!=undefined && item_name=="BSD:TDM_LAYER_EVA_C") {
            selectedLayer = item;
          }
        }

        if(selectedLayer==undefined){
         //console.log("add new  TDM_LAYER_EVA_C");
          TDM_LAYER_EVA_C.setZIndex(500);
          this.map.addLayer(TDM_LAYER_EVA_C);
        }
      },

      /**
       * 查询地图点击查询值
       * */
      readMapPoint(evt){
        //Remove the map overlay
        this.defaultMapOverlay.setPosition(undefined);
        //校验点是否有效
        let view = this.map.getView();
        let viewResolution = view.getResolution();
        let source =this.basicOceanLayer.getSource();
        let url = source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
        let _this = this;
        this.axios.get(url).then((response)=>{
          //console.log("checkQueryPointValid::response.data = ",response.data);
          const selectedFeatures =response.data.features;
          //只有点击非海洋范围的图层才能进行下一步的栅格查询
          if(selectedFeatures.length==0){
            console.log("selectedRasterMapSrouce = ",this.selectedRasterMapSrouce);
            if(this.selectedRasterMapSrouce=="population_risks_heatwaves:risk_pop_ht_2000s_s0_value_mme_global"){
              //复合数据查询
              _this.dType = 2;
              _this.readSelectedPointData_composedModel(evt.coordinate);
            }else {
              //单数据查询
              _this.dType = 1;
              _this.readSelectedPointData(evt);
            }
          }
        })
      },
      /**
       * @description 查询点复合数据
       * */
      async readSelectedPointData_composedModel(coordinate){
        let sMenu = this.lastClicedMenuItem.toLowerCase();
        console.log("readSelectedPointData_composedModel && sMenu= ",sMenu);
        const wms_params = ["2000s_s0","2030s_rcp26","2030s_rcp45","2030s_rcp85","2050s_rcp26","2050s_rcp45","2050s_rcp85"];
        const wms_params_label = ["Baseline",
          "2030s-Rcp2.6-SSP1","2030s-Rcp4.5-SSP2","2030s-Rcp8.5-SSP3",
          "2050s-Rcp2.6-SSP1","2050s-Rcp4.5-SSP2","2050s-Rcp8.5-SSP3"];
        if(sMenu=="heatwave"){
          let workspace = "POPULATION_RISKS_HEATWAVES";
          let wms_root = workspace+":RISK_POP_HT_";
          let wms_valus = new Array();
          for(let i=0;i<wms_params.length;i++){
            let item = wms_params[i];
            let layer_code = wms_root;
            layer_code +=item;
            layer_code +="_"+this.radioG_cc_prcptot_type+"_"+this.radioG_cc_prcptot_mm+"_GLOBAL";
            layer_code = layer_code.toUpperCase();
            //console.log("index = ",i," & value = ",layer_code);
            console.log("1");
            let raster_value =  await this.WSMFeatureQuery(workspace.toLowerCase(),layer_code.toLowerCase(),coordinate);
            //判断是不极小值
            if(raster_value!=undefined && parseFloat(raster_value)<0){
              let raster_value_str = raster_value+"";
              if(raster_value_str.indexOf("e+")>-1){
                raster_value = "NO DATA";
              }
            }
            //处理科学基数
            if(raster_value!=undefined &&  raster_value!="NO DATA"){
              raster_value = parseFloat(raster_value)*this.getRasterValueRate();
            }

            //
            console.log("raster_value = ",raster_value);
            let queryData = {
              "lable":wms_params_label[i],
              "value":raster_value
            };
            wms_valus.push(queryData);
          }
          console.log("wms_valus = ",wms_valus);
          this.tableData = wms_valus;

          this.defaultMapOverlay.setPosition(coordinate);

        }

      },

      async WSMFeatureQuery(workspace,layer_code,coordinate){
        let wms_source =  this.$olMapUtils.getWMSSource(workspace,layer_code);
        //console.log("wms_source = ",wms_source);
        let view = this.map.getView();
        let viewResolution = view.getResolution();
        let rUrl = wms_source.getFeatureInfoUrl(coordinate, viewResolution, view.getProjection(), {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
        //console.log("layer_code = ",layer_code," && request url  = ",rUrl);
        console.log("2-1");
        let raster_data = undefined;
        await this.axios.get(rUrl).then((response)=>{
          //console.log("response.data = ",response.data);
          const selectedFeatures =response.data.features;
          if(selectedFeatures.length>0) {
            const selectedFeature = selectedFeatures[0];
            const selectedFeature_properties = selectedFeature.properties;
            let raster_value = selectedFeature_properties.GRAY_INDEX;
            raster_value = raster_value.toFixed(2);
            console.log("layer_code = ",layer_code," && raster_value = ",raster_value);
            raster_data = raster_value;
          }
        })
        return raster_data;
      },

      getRasterValueRate(){
        let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        let rate = undefined;
        let title = BSDConfigLegendTitle[current_layer_code];
        if(title!=undefined){
          let title_seg = title.split("#");
          title_seg.forEach(item=>{
            if(item.indexOf("^")>-1){
              rate = item.split("^")[1]
            }
          })
        }
        let raster_value_rate = 1;
        if(rate!=undefined){
          for(let i=0;i<rate;i++){
            raster_value_rate = raster_value_rate*(0.1);
          }
        }
        return raster_value_rate;
      },


      /**
       * @description - 查询栅格图层单击点值 - 2021年1月22日17:47:39
       * */
      readSelectedPointData(evt){
        var view = this.map.getView();
        var viewResolution = view.getResolution();
        var source =this.selectedRasterMapLayer.getSource();
        var url = source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});

        console.log("readSelectedPointData::url = ",url);
        this.axios.get(url).then((response)=>{
          console.log("response.data = ",response.data);
          const selectedFeatures =response.data.features;
          if(selectedFeatures.length>0) {
            const selectedFeature = selectedFeatures[0];
            const selectedFeature_properties = selectedFeature.properties;
            this.selectedRasterMapData = selectedFeature_properties.GRAY_INDEX;
            console.log("this.selectedRasterMapData = ",this.selectedRasterMapData);

            if(selectedFeature_properties.GRAY_INDEX == undefined){
              console.log("this.selectedRasterMapData == undefined value");
            }

            if(this.selectedRasterMapData==null){
              this.selectedRasterMapData = "NO DATA";
              this.defaultMapOverlay.setPosition(evt.coordinate);
              return;
            }

            //处理科学基数
            if(this.selectedRasterMapData!=undefined &&  this.selectedRasterMapData!="NO DATA"){
              console.log("处理科学基数");
              let raster_rate = this.getRasterValueRate();
              console.log("raster_rate = ",raster_rate);
              this.selectedRasterMapData = parseFloat(this.selectedRasterMapData)*this.getRasterValueRate();
            }

            if((this.selectedRasterMapData && this.selectedRasterMapData !=null) || parseFloat(this.selectedRasterMapData)!=0){
              console.log("111");
              if(parseFloat(this.selectedRasterMapData)<0){
                console.log("222");
                let selectedRasterMapData_str = this.selectedRasterMapData+" ";
                if(selectedRasterMapData_str.indexOf("e+")>-1) {
                  console.log("negitive value && value is too small");
                  this.selectedRasterMapData = "NO DATA";
                  this.defaultMapOverlay.setPosition(undefined);
                  return;
                }else {
                  //弹出查询的数值
                  console.log("333");
                }
              }
              this.defaultMapOverlay.setPosition(evt.coordinate);
            } else {
              this.defaultMapOverlay.setPosition(undefined);
            }




          }
        })
      },









      initMapOverlay(){
        if(this.map && this.defaultMapOverlay==undefined){
          let container = document.getElementById('popup');
          let closer = document.getElementById('popup-closer');
          let closer2 = document.getElementById('popup-closer2');
          let overlay = new Overlay({
            element: container,
            autoPan: true,
            autoPanAnimation: {
              duration: 250,
            },
          });
          closer.onclick = function () {
            overlay.setPosition(undefined);
            closer.blur();
            return false;
          };

          closer2.onclick = function (){
            overlay.setPosition(undefined);
            closer.blur();
            return false;
          }

          this.map.addOverlay(overlay);
          this.defaultMapOverlay = overlay;
        }
      },


      /**
       * 样式文件更新 Update time is 2020年12月9日13:07:58
       * */
      updateMapLengends(layer_code,wms_ws){

        let legends_params_layercode = layer_code;
        let legends_params_layercodes = legends_params_layercode.split(":");
        legends_params_layercode = legends_params_layercodes[legends_params_layercodes.length-1];
        let legends_params = {
          layerName:legends_params_layercode,
          workspace:wms_ws};
        console.log("api_bnu_getLayerLegends::prams = ",legends_params);
        api_bnu_getLayerLegends(legends_params).then(res=>{
          console.log("api_bnu_getLayerLegends:: data = ",res.data);
          let res_data = res.data;
          if(res_data==undefined||res_data.length==0){
           this.$message.error("Style DATA UNDEFINED");
          }
          else {
            let res_data_data = res_data.data;
            let selectedSLDFile = JSON.parse(res_data_data);
            console.log("obj_resData.data = ",selectedSLDFile);
            this.selectedMapLegendsStyle = reverseMapLegend(selectedSLDFile);
            if(this.legendModel==1){
              this.$refs.ref_mapLegend.updateHeight();
            }
            this.$refs.ref_mapLegend.updateHeight();
          }
        })
      },

      /**
       * @author zhangchengguo at 2020年12月07日22:36:22
       * @description 更新海洋背景
       * */
      updateOceanMapLayer(){

        let selected_cascader_laster = this.selected_cascader[0];
        this.$olMapUtils.updateOceanMapLayer(this.map,selected_cascader_laster.toLowerCase());

        // console.log(" ");
        // console.log("-------");
        // let oceanLayerName = "BSD:ocean";
        // let mapLayerStyle = "ocean_baseline";
        //
        // let selected_cascader_laster = this.selected_cascader[0];
        // selected_cascader_laster = selected_cascader_laster.toLowerCase();
        // if(selected_cascader_laster=="2000s_s0"){
        //   mapLayerStyle = "ocean_baseline";
        // }else if(selected_cascader_laster=="2030s") {
        //   mapLayerStyle = "ocean_2030s";
        // }else if(selected_cascader_laster=="2050s") {
        //   mapLayerStyle = "ocean_2050s";
        // }
        // console.log("updateOceanMapLayer::selected_cascader_laster = ",selected_cascader_laster);
        // this.map.getLayers().forEach(function (layer) {
        //   const layer_name = layer.name;
        //   if(layer_name==oceanLayerName){
        //     layer.getSource().updateParams({'STYLES': mapLayerStyle});
        //   }
        // })
      }
    },

    mounted() {
      this.initLayout();
      this.initMap();

      this.basicOceanLayer = this.$olMapUtils.addWMSLayer({layerName:"bsd:ocean", layerCode:"bsd:ocean", visible:true,zIndex:9,});
      this.$olMapUtils.addWMSLayer({layerName:"bsd:country",layerCode:"bsd:country_project",visible:true,zIndex:10});
      this.$olMapUtils.addWMSLayer({layerCode:"bsd:military_border",zIndex:13});
      this.$olMapUtils.addWMSLayer({layerCode:"bsd:undefine_country_border",zIndex:14});
      this.$olMapUtils.addWMSLayer({layerCode:"bsd:geogrid_4326",zIndex:15});


      // this.$olMapUtils.addWMSLayer(
      //   {layerCode:"DZZH:QXXX_FCST_2021041208_072_SHP",
      //   zIndex:16,
      //   geoServer:geoserver_test});

      //geoServer =  /geo_bsd/geoserver/population_risks_flood/wms  && layerCode =  population_risks_flood:risk_pop_fld_2000s_s0_value_mme_global
      // this.$olMapUtils.addWMSLayer({
      //   layerCode:"population_risks_flood:risk_pop_fld_2000s_s0_value_mme_global", zIndex:17, geoServer:"/geo_bsd/geoserver/population_risks_flood/wms"});


      // let serviceParams = {
      //   serviceType: "geoserver",
      //   url: "/geo_bsd/geoserver/population_risks_flood/wms",
      //   layer: "population_risks_flood:risk_pop_fld_2000s_s0_value_mme_global",
      // };
      // let nlayer = this.$olMapUtils.createWMSLayer(serviceParams);
      // this.map.addLayer(nlayer);



      let _this = this;
      this.map.on('click', function (event) {
        if(_this.selectedRasterMapLayer){
          _this.readMapPoint(event);
        }
      });

      //
      this.radioG_MapTime_updateConfig();
      //
      this.$watch('selectedRasterMapSrouce', function (newValue, oldValue) {//a是属性名，表示要监听的对象
        this.mapSourceLayout();
      });
      this.mapSourceLayout();
      //加载默认地图渲染图层
      this.openDefaultMapSource();
      //
      this.initMapOverlay();
      //
      //this.legend_layoutupdate_show();
      this.loginUser = this.$appStorage.getUserMailbox();


      this.menuSpan=0;
      this.mapResize();

      this.legendModel = 0;
      this.legend_layoutupdate_show();

      setTimeout(function (){
        _this.$refs.ref_mapLegend.updateHeight();
      },1000);


    }
  }
</script>




<style scoped lang="scss">
@import "BSDMap";



.pdf-el-dialog .pdf-dialog {
  width: 100%;
  height: 70vh;
  background-color: transparent;
  overflow-y: scroll;
}
.pdf-el-dialog .pdf-dialog .el-dialog__body {
  padding-bottom: 0px;
}

/* 跳转到外面 */
.pdf-el-dialog .icon-analysis {
  font-size: 18px;
  position: relative;
  margin-right: 35px;
  float: right;
  margin-top: -40px;
  cursor: pointer;
}
.pdf-el-dialog .icon-analysis:hover{
  color: red;
}






.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 70px;
  font-size: 17px;
}
.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  color: red;
  font-size: 14px;
}
.ol-popup-closer:after {
  content: "✖";
}


.css_cascader{
  width: 200px;
}

</style>



// WEBPACK FOOTER //
// src/view/BSD/BSDMapRISK.vue